import React, { useEffect, useRef, useState } from "react";
import * as styles from "./velavu-toast-container.module.scss";
import { classArr } from "../helper/style-helper";

const TRANSITION_DURATION = parseInt(styles.transitionDuration);

export interface VelavuToastContainerProps {
	children?: React.ReactNode;
	show: boolean;
	onAnimatedIn?: () => void;
	onAnimatedOut?: () => void;
}

enum AnimationState {
	Initial,
	Show,
	Hide,
}

export default function VelavuToastContainer(props: VelavuToastContainerProps) {
	// Track the animation state.
	// We transition immediately from initial to show or hide
	// to force the CSS animation to trigger.
	const [animationState, setAnimationState] = useState(
		AnimationState.Initial,
	);
	const lastTimeout = useRef<ReturnType<typeof setTimeout> | undefined>(
		undefined,
	);
	useEffect(() => {
		clearTimeout(lastTimeout.current);

		if (props.show) {
			setAnimationState(AnimationState.Show);
			if (props.onAnimatedIn) {
				lastTimeout.current = setTimeout(
					props.onAnimatedIn,
					TRANSITION_DURATION,
				);
			}
		} else {
			setAnimationState(AnimationState.Hide);
			if (props.onAnimatedOut) {
				lastTimeout.current = setTimeout(
					props.onAnimatedOut,
					TRANSITION_DURATION,
				);
			}
		}
	}, [
		setAnimationState,
		props.show,
		props.onAnimatedIn,
		props.onAnimatedOut,
	]);

	// Map the animation state to a class with transitions
	let animationClass: string | undefined;
	switch (animationState) {
		case AnimationState.Show:
			animationClass = styles.show;
			break;
		case AnimationState.Hide:
			animationClass = styles.hide;
			break;
	}

	return (
		<div className={classArr(styles.container, animationClass)}>
			{props.children}
		</div>
	);
}
